export const uploadEnded = (payload) => ({
  type: 'app/UPLOAD_ENDED',
  payload,
});
